import React from "react";
import { tableRowNavigation } from '../../helpers/TableRowNavigation';
import { connect } from "react-redux";
import {IconButton} from "@material-ui/core";
import {apiCall} from "../../helpers/MainHelper";
import Swal from "sweetalert2";
import ReactDOMServer from "react-dom/server";
import ReactLoading from "react-loading";

class QrListTable extends React.Component {

  handleDelete = async (qrID) => {
    const result = await Swal.fire({
      title: 'Silmek istediğinize emin misiniz?',
      text: "Bu işlem geri alınamaz!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Evet, sil!',
      cancelButtonText: 'Hayır, iptal et',
      preConfirm: async () => {
        const confirmButton = Swal.getConfirmButton();
        const originalButtonText = confirmButton.innerHTML;
        confirmButton.disabled = true;
        confirmButton.innerHTML = ReactDOMServer.renderToString(<ReactLoading type="spin" width={'24px'} height={'24px'} color="#ffffff" />);

        try {
          await apiCall('business/settings/qr-delete/'+qrID,'delete',null)
          await this.props.fetchQrs();
          return true;
        } catch (error) {
          return false;
        } finally {
          confirmButton.innerHTML = originalButtonText;
          confirmButton.disabled = false;
        }
      }
    });

    if (result.isConfirmed) {
      if (result.value) {
        Swal.fire(
            'Silindi!',
            'Şube başarıyla silindi.',
            'success'
        );
      } else {
        Swal.fire(
            'Hata!',
            'Silme işlemi başarısız oldu.',
            'error'
        );
      }
    }
  }
  render() {
    const { bodyData } = this.props;

    return (

        <div className="table-responsive">
          <table className="table m-b-0 table-hover">
            <thead className="thead-light">
            <tr>
              <th>Şube</th>
              <th>İşlemler</th>
            </tr>
            </thead>
            <tbody>
            {bodyData.length > 0 ? (
                bodyData.map((data, i) => {
                  const reviewHref = `${process.env.REACT_APP_MAIN_URL}/qr-review/`+ data.branch_id;
                  return (
                      <tr {...tableRowNavigation(() => window.open(reviewHref, '_blank', 'noopener,noreferrer'))} key={"dihf" + i}>
                        <td>
                          <span className="badge badge-success">{data.branch.name}</span>
                        </td>
                        <td className="project-title">

                          <IconButton className="btn btn-outline-secondary" onClick={() => this.handleDelete(data.id)} style={{cursor: 'pointer',marginLeft:-15}}>
                            <button type="button" className="btn btn-outline-danger btn-sm" ><i className="icon-trash"></i></button>
                          </IconButton>
                        </td>
                      </tr>
                  );
                })
            ) : (
                <tr>
                  <td colSpan="2" className="text-center">
                    <div className="alert alert-warning mb-0">
                      QR Bulunamadı!
                    </div>
                  </td>
                </tr>
            )}
            </tbody>
          </table>
        </div>

    );
  }
}

const mapStateToProps = ({mailInboxReducer}) => ({});

export default connect(mapStateToProps, {})(QrListTable);
